"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { SortDirection } from "@/entities/ISort";
import CommonTableSortIcon from "@/components/user/utils/icons/CommonTableSortIcon";
import { CommonSelectItemProps } from "../CommonSelect";
export default function CommonTabsTab(props) {
  const $ = _c(30);
  const {
    item,
    activeItem,
    setSelected,
    sortDirection
  } = props;
  let t0;
  if ($[0] !== activeItem || $[1] !== item.value) {
    t0 = () => item.value === activeItem;
    $[0] = activeItem;
    $[1] = item.value;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const getIsActive = t0;
  const [isActive, setIsActive] = useState(getIsActive());
  let t1;
  if ($[3] !== getIsActive) {
    t1 = () => {
      setIsActive(getIsActive());
    };
    $[3] = getIsActive;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== activeItem) {
    t2 = [activeItem];
    $[5] = activeItem;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== isActive) {
    t3 = () => {
      let response;
      if (isActive) {
        response = "tw-bg-iron-800 tw-text-iron-100";
      } else {
        response = " tw-bg-iron-950 hover:tw-bg-iron-900 tw-text-iron-500 hover:tw-text-iron-100";
      }
      return response;
    };
    $[7] = isActive;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const getDynamicClasses = t3;
  const [dynamicClasses, setDynamicClasses] = useState(getDynamicClasses());
  let t4;
  if ($[9] !== getDynamicClasses) {
    t4 = () => {
      setDynamicClasses(getDynamicClasses());
    };
    $[9] = getDynamicClasses;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isActive) {
    t5 = [isActive];
    $[11] = isActive;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  const [shouldRotate, setShouldRotate] = useState(false);
  let t6;
  if ($[13] !== item.value || $[14] !== setSelected) {
    t6 = () => {
      setSelected(item.value);
      setShouldRotate(false);
    };
    $[13] = item.value;
    $[14] = setSelected;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const onSelected = t6;
  const t7 = isActive ? "tw-p-[1px] tw-flex tw-rounded-lg tw-bg-gradient-to-b tw-from-iron-700 tw-to-iron-800" : "tw-p-[1px] tw-flex tw-rounded-lg";
  let t8;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setShouldRotate(true);
    t9 = () => setShouldRotate(false);
    $[16] = t8;
    $[17] = t9;
  } else {
    t8 = $[16];
    t9 = $[17];
  }
  const t10 = `${dynamicClasses} tw-whitespace-nowrap tw-flex-1 sm:tw-flex-none tw-px-3 tw-py-2 tw-text-sm tw-leading-5 tw-font-semibold tw-border-0 tw-rounded-lg tw-transition-all tw-duration-300 tw-ease-out`;
  let t11;
  if ($[18] !== isActive || $[19] !== shouldRotate || $[20] !== sortDirection) {
    t11 = sortDirection && <span className="-tw-mt-0.5 tw-ml-2"><CommonTableSortIcon direction={isActive ? sortDirection : SortDirection.DESC} isActive={isActive} shouldRotate={isActive && shouldRotate} /></span>;
    $[18] = isActive;
    $[19] = shouldRotate;
    $[20] = sortDirection;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== item.label || $[23] !== onSelected || $[24] !== t10 || $[25] !== t11) {
    t12 = <button type="button" onClick={onSelected} onMouseEnter={t8} onMouseLeave={t9} className={t10}>{item.label}{t11}</button>;
    $[22] = item.label;
    $[23] = onSelected;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t7) {
    t13 = <div className={t7}>{t12}</div>;
    $[27] = t12;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}